import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VogueHero from "@/components/VogueHero";
import VogueAbout from "@/components/VogueAbout";
import ProjectGrid from "@/components/ProjectGrid";
import VogueContact from "@/components/VogueContact";

const Home = () => {
  return (
    <div className="bg-white">
      <VogueHero />
      <VogueAbout />
      <ProjectGrid />
      <VogueContact />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
